import { rest } from "src/common/rest";
import { apiObjUrl } from "src/common/apiUrl";
import { ZUid } from "src/types/zUid";
import { ZAttributeSum, zAttributeSum } from "./ChildEntities.types";
import {
  ChildEntitiesRestriction,
  makeChildEntitiesRestrictionFilters,
} from "./childEntitiesRestriction";

export const loadChildEntsSummary = async (
  objectId: ZUid,
  parentEntityId: ZUid,
  childAttributeId: ZUid,
  parentLinkAttributeId: ZUid,
  attributeIds: ZUid[],
  query?: string,
  restriction?: ChildEntitiesRestriction,
): Promise<ZAttributeSum[]> => {
  const resp = await rest.get(apiObjUrl("/v2/entities/child-entities-sum"), {
    params: {
      objectId,
      parentEntityId,
      childAttributeId,
      parentLinkAttributeId,
      attributeIds,
      query,
      ...makeChildEntitiesRestrictionFilters(restriction),
    },
    paramsSerializer: {
      indexes: null,
    },
  });
  return zAttributeSum.array().parse(resp.data);
};
